import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Route, Switch } from '@treams/treams-routes';
import { Container, Jumbo, Tabs } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import { UserSettingsLanguage } from 'packages/kakapo-ui-application/pages/users/UserSettingsContainer';
import { UserUpdateMissionModalForm } from 'packages/kakapo-ui-application/pages/users/UserUpdateMissionModal';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';
import { UserImageUploadModalContents } from 'packages/kakapo-ui-application/pages/users/UserImageUploadModalContainer';
import { ImageAspectRatio, ImageShape } from 'packages/kakapo-ui-kit/types/Image';

import PersonalNotificationSettings from './PersonalNotificationSettings';

function UpdateMission() {
	const viewer = useAuthenticatedUser();
	const query = graphql.useUserQuery({ variables: { id: viewer.id } });

	if (!query.data) {
		return null;
	}

	return <UserUpdateMissionModalForm user={query.data.user as graphql.User} />;
}

export default function PersonalSettings() {
	const { t } = useTranslation();
	const viewer = useAuthenticatedUser();

	return (
		<Box>
			<Jumbo
				title={t('personalSettings.title')}
				description={t('personalSettings.description')}
				footer={
					<Tabs.Container>
						<Tabs.Item path="/personal-settings" title={t('personalSettings.avatar.title')} />
						<Tabs.Item
							path="/personal-settings/mission"
							title={t('personalSettings.mission.title')}
						/>
						<Tabs.Item
							path="/personal-settings/language"
							title={t('personalSettings.language.title')}
						/>
						<Tabs.Item
							path="/personal-settings/notifications"
							title={t('personalSettings.notifications.title')}
						/>
					</Tabs.Container>
				}
			/>
			<Switch>
				<Route exact path="/personal-settings">
					<Container py={3}>
						<UserImageUploadModalContents
							userId={viewer.id}
							imageSpecification={{
								title: 'avatar',
								key: 'avatars',
								aspectRatio: ImageAspectRatio.Square,
								shape: ImageShape.Circlular,
								allowedExtensions: ['jpg', 'jpeg', 'png'],
							}}
						/>
					</Container>
				</Route>
				<Route path="/personal-settings/mission">
					<Container py={3}>
						<UpdateMission />
					</Container>
				</Route>
				<Route path="/personal-settings/language">
					<Container py={3}>
						<UserSettingsLanguage />
					</Container>
				</Route>
				<Route path="/personal-settings/notifications">
					<PersonalNotificationSettings />
				</Route>
			</Switch>
		</Box>
	);
}
